import {
	CONFIG_PARAM_CAR,
	CONFIG_PARAM_COLOR,
	CONFIG_PARAM_UPHOLSTERY,
	CONFIG_PARAM_WHEEL,
	CONFIG_PARAM_PACKS
} from '@/constants/selection_params';
import { type ConfigOriginKey } from '@/lib/config-origin/domain';
import { type BasketQuoteItem } from '@/lib/order/domain/basket';
import { type OrderItem } from '@/lib/order/domain/order';
import {
	CAR_ID_PARAM,
	EXTERIOR_COLOR_INTERNAL_CODE_PARAM,
	FACTORY_MODEL_PARAM,
	KATASHIKI_PARAM,
	SSN_PARAM,
	SUFFIX_PARAM,
	UPHOLSTERY_INTERNAL_CODE_PARAM
} from '@/lib/order/utils/constants';
import { type SelectedVehicle } from '@/providers/car-store-provider';

export function getSEACCarParams(orderOrBasketItem: OrderItem | BasketQuoteItem) {
	return {
		[CAR_ID_PARAM]: orderOrBasketItem.product.configuratorId,
		[EXTERIOR_COLOR_INTERNAL_CODE_PARAM]: orderOrBasketItem.exteriorColour.localMarketId,
		[FACTORY_MODEL_PARAM]: orderOrBasketItem.suffix.modelCode,
		[KATASHIKI_PARAM]: orderOrBasketItem.suffix.katashiki,
		[SSN_PARAM]: orderOrBasketItem.suffix.ssnCode,
		[SUFFIX_PARAM]: orderOrBasketItem.suffix.suffixCode,
		[UPHOLSTERY_INTERNAL_CODE_PARAM]: orderOrBasketItem.interiorColour.localMarketId
	};
}

export function getConfigCarParams(selectedVehicle: SelectedVehicle) {
	return {
		[CONFIG_PARAM_CAR]: selectedVehicle.car.id,
		[CONFIG_PARAM_COLOR]: selectedVehicle.color.id,
		[CONFIG_PARAM_UPHOLSTERY]: selectedVehicle.upholstery.id,
		[CONFIG_PARAM_WHEEL]: selectedVehicle.wheel.id,
		[CONFIG_PARAM_PACKS]: selectedVehicle.packs?.map((pack) => pack.id).join(',') || ''
	};
}

export function getCarParams(
	origin: ConfigOriginKey,
	orderOrBasketItem: OrderItem | BasketQuoteItem | undefined,
	selectedVehicle: SelectedVehicle
) {
	if (!orderOrBasketItem) return {};

	return origin === 'configurator' ? getConfigCarParams(selectedVehicle) : getSEACCarParams(orderOrBasketItem);
}
